const STEPS = [
  {
    n: "01",
    title: "Tell us what you need — and exactly what you’re looking for",
    body: "Location, frequency of visits, budget, family needs, religious and lifestyle preferences, and your favourite months in Israel.",
  },
  {
    n: "02",
    title: "We match you, carefully",
    body: "Our proprietary system pairs families whose values, usage patterns, expectations and budgets align — the quiet secret of harmonious co‑ownership.",
  },
  {
    n: "03",
    title: "You own your share",
    body: "Real, registered title for 25–50%, governed by a clear legal constitution covering rotation, costs, exit and succession. We connect you with our trusted lawyer, mortgage broker, currency agent and management company — so every part of the journey is handled by people we’d use ourselves.",
  },
  {
    n: "04",
    title: "We manage everything",
    body: "Property care, bookings, rentals, taxes, cleaning, changeovers and bills. One concierge point of contact, full transparency.",
  },
  {
    n: "05",
    title: "You arrive and enjoy",
    body: "Your home is prepared, the fridge is stocked, the keys are waiting. You step in and it already feels like yours — because it is.",
  },
  {
    n: "06",
    title: "Stay in the loop, always",
    body: "You’re onboarded into our owner app — monitor income, expenses, upcoming bookings and rental performance in real time, and message us directly. Transparent, accountable, on your phone.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      data-testid="how-it-works-section"
      className="relative bg-[var(--bone)] text-[var(--ink)]"
    >
      <div className="container mx-auto px-6 md:px-12 lg:px-16 max-w-[1400px] py-24 md:py-36 lg:py-44">
        <div className="max-w-3xl reveal">
          <div className="text-overline text-[var(--ink)]/55 mb-6">How it works</div>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-[3.8rem] leading-[1.05] tracking-tight">
            Six quiet steps. <span className="italic text-[var(--gold)]">One home in Israel.</span>
          </h2>
        </div>

        <ol className="mt-16 md:mt-24 relative">
          <div
            aria-hidden
            className="absolute left-[1.1rem] md:left-[2.4rem] top-2 bottom-2 w-px bg-gradient-to-b from-transparent via-[var(--ink)]/20 to-transparent"
          />
          {STEPS.map((s, i) => (
            <li
              key={s.n}
              data-testid={`step-${i + 1}`}
              className="relative grid grid-cols-[3rem_1fr] md:grid-cols-[5.5rem_1fr] gap-6 md:gap-10 py-8 md:py-12 reveal"
            >
              <div className="relative">
                <span className="relative z-10 inline-flex items-center justify-center w-10 h-10 md:w-14 md:h-14 rounded-full bg-[var(--ink)] text-[var(--bone)] font-serif-display text-base md:text-lg">
                  {s.n}
                </span>
              </div>
              <div className="pt-1.5 md:pt-3 pb-4">
                <h3 className="font-serif-display text-2xl md:text-3xl lg:text-[2.2rem] leading-tight tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 max-w-2xl text-[var(--ink)]/70 text-base md:text-lg leading-relaxed font-light">
                  {s.body}
                </p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
